export default __webpack_public_path__ + "static/media/default-card-thumbnail.d7e678ca.png";